export default __webpack_public_path__ + "static/media/Illustration.13bd31bd.svg";